/**
 * نقشه‌ی پرسپکتیوِ چهارگوش به چهارگوش — هم پنل (فرشِ تختِ شهرِ تازه، panel/lib/rug.ts) و هم صحنه‌ی
 * میز («میزِ من»: فرشِ دیگری با پرسپکتیو روی فرشِ نقاشی‌شده‌ی پرده، scene/table.ts) از این‌جا.
 */
export type Pt = [number, number];

/**
 * ضریب‌های نقشه‌ی پرسپکتیو از `dst` به `src`: (x, y) ↦ ((a x + b y + c) / (g x + h y + 1), …).
 * هشت معادله، هشت مجهول؛ حذفِ گاوسی با محور، چون گوشه‌ها عددِ پیکسلیِ بزرگ‌اند.
 */
export function homography(dst: Pt[], src: Pt[]): number[] {
  const m: number[][] = [];
  for (let i = 0; i < 4; i++) {
    const [x, y] = dst[i]!, [u, v] = src[i]!;
    m.push([x, y, 1, 0, 0, 0, -u * x, -u * y, u]);
    m.push([0, 0, 0, x, y, 1, -v * x, -v * y, v]);
  }
  for (let c = 0; c < 8; c++) {
    let p = c;
    for (let r = c + 1; r < 8; r++) if (Math.abs(m[r]![c]!) > Math.abs(m[p]![c]!)) p = r;
    [m[c], m[p]] = [m[p]!, m[c]!];
    const piv = m[c]![c]!;
    if (Math.abs(piv) < 1e-12) throw new Error("گوشه‌ها روی یک خط‌اند");
    for (let r = 0; r < 8; r++) {
      if (r === c) continue;
      const f = m[r]![c]! / piv;
      for (let k = c; k < 9; k++) m[r]![k]! -= f * m[c]![k]!;
    }
  }
  return m.map((row, i) => row[8]! / row[i]!);
}


/**
 * `transform` ِ CSS که مستطیلِ w×h (با transform-origin: 0 0) را روی چهارگوشِ `quad` می‌نشاند —
 * همان هموگرافی، به شکلِ matrix3d.
 */
export function quadTransform(w: number, h: number, quad: Pt[]): string {
  const [a, b, c, d, e, f, g, k] = homography([[0, 0], [w, 0], [w, h], [0, h]], quad);
  return `matrix3d(${a},${d},0,${g},${b},${e},0,${k},0,0,1,0,${c},${f},0,1)`;
}
